export var VERSION = '2.17.3';
//# sourceMappingURL=version.js.map